import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import { OVERVIEW_ROUTE, STORES_ROUTE, CART_SETTINGS_ROUTE, CART_PROMOS_ROUTE, DELIVERY_AREAS_ROUTE, PROMOS_ROUTE, ORDERS_ROUTE, CUSTOMER_SEGMENT_ROUTE, BROADCAST_ROUTE, } from '@/helpers/constants/StoreManagementRoutes';
import { REBATES_SUBMISSIONS_ROUTE, REBATES_VOUCHERS_ROUTE, } from '@/helpers/constants/StoreAddOnsRoutes';
import BaseSideNav from '@/components/v2/BaseSideNav.vue';
import { StoreManagementStatus } from '@/helpers/entities/enums/v2/StoreManagementStatus';
import { VoucherStatus } from '@/helpers/entities/enums/v2/VoucherStatus';
import AppDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
let MallStoresManagementBundle = class MallStoresManagementBundle extends Mixins(AppDetailsMixin) {
    constructor() {
        super(...arguments);
        this.childrenMenuIcon = 'keyboard_arrow_right';
        this.pending = StoreManagementStatus.Pending;
        this.valid = VoucherStatus.Valid;
    }
    get params() {
        return { appUUID: this.appUuid };
    }
    get currentRoute() {
        return this.$router.currentRoute;
    }
    get marketingMenuIsActive() {
        return this.currentRoute.meta.parentMenu === 'store-management-marketing-tools';
    }
    get overviewMenuItem() {
        return {
            icon_path: require('./assets/overview-orange.svg'),
            text: OVERVIEW_ROUTE.title,
            path: {
                name: OVERVIEW_ROUTE.name,
                params: this.params,
            },
            exact: false,
        };
    }
    get cartMenuItem() {
        return {
            icon_path: require('./assets/cart-orange.svg'),
            text: 'Cart',
            model: false,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: CART_SETTINGS_ROUTE.title,
                    path: {
                        name: CART_SETTINGS_ROUTE.name,
                        params: this.params,
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: CART_PROMOS_ROUTE.title,
                    path: {
                        name: CART_PROMOS_ROUTE.name,
                        params: this.params,
                    },
                    exact: false,
                },
            ],
        };
    }
    get deliveryMenuItem() {
        return {
            icon_path: require('./assets/delivery-orange.svg'),
            text: DELIVERY_AREAS_ROUTE.title,
            path: {
                name: DELIVERY_AREAS_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get promosMenuItem() {
        return {
            icon_path: require('./assets/promos-orange.svg'),
            text: PROMOS_ROUTE.title,
            path: {
                name: PROMOS_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get storesMenuItem() {
        return {
            icon_path: require('./assets/store.svg'),
            text: STORES_ROUTE.title,
            path: {
                name: STORES_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get ordersMenuItem() {
        return {
            icon_path: require('./assets/order-orange.svg'),
            text: ORDERS_ROUTE.title,
            path: {
                name: ORDERS_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get rebatesMenuItem() {
        return {
            icon_path: require('./assets/rebates-orange.svg'),
            text: 'Rebates',
            model: false,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: REBATES_SUBMISSIONS_ROUTE.title,
                    path: {
                        name: 'submissions-by-status',
                        params: { status: this.pending },
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: REBATES_VOUCHERS_ROUTE.title,
                    path: {
                        name: 'vouchers-by-status',
                        params: { status: this.valid },
                    },
                    exact: false,
                },
            ],
        };
    }
    get customerSegmentMenuItem() {
        return {
            icon: require('./assets/customer-segment.svg'),
            text: CUSTOMER_SEGMENT_ROUTE.title,
            path: {
                name: CUSTOMER_SEGMENT_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get broadcastMenuItem() {
        return {
            icon: require('./assets/broadcast-orange.svg'),
            text: BROADCAST_ROUTE.title,
            path: {
                name: BROADCAST_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get notificationMenuItem() {
        return {
            icon_path: require('./assets/notification.svg'),
            text: 'Notification Manager',
            path: {
                name: 'store-management-notifications',
                params: this.params,
            },
            exact: true,
        };
    }
    get referralMenuItem() {
        return {
            icon_path: require('./assets/referral-link.svg'),
            text: 'Referral',
            path: {
                name: 'ecommerce-referral',
                params: this.params,
            },
            exact: false,
        };
    }
    get marketingToolsItem() {
        return {
            icon_path: require('./assets/broadcast.svg'),
            text: 'Marketing Tools',
            model: this.marketingMenuIsActive,
            children: [this.customerSegmentMenuItem, this.broadcastMenuItem],
        };
    }
    get menuItems() {
        const menu = [
            this.overviewMenuItem,
            this.storesMenuItem,
            this.cartMenuItem,
            this.deliveryMenuItem,
            this.promosMenuItem,
            this.ordersMenuItem,
            this.referralMenuItem,
            this.notificationMenuItem,
        ];
        if (!!this.appDetails && !!this.appDetails.rebatable) {
            menu.push(this.rebatesMenuItem);
        }
        menu.push(this.marketingToolsItem);
        return menu;
    }
};
MallStoresManagementBundle = __decorate([
    Component({
        components: {
            BaseSideNav,
        },
    })
], MallStoresManagementBundle);
export default MallStoresManagementBundle;
